import { createChildListModalComponent } from 'factories/ChildListModal'
import Filter from 'containers/Rfqs/UpdatePrices/Filter'

export default createChildListModalComponent({
  getStorageKey: (self) => 'rfqs.updatePrices',
  getSettingsType: (self) => 'updatePrices',
  allowPagination: (self) => false,
  initialFilterDto: (self) => ({ showDifferencesOnly: true }),
  filterItems: (self) => (each) => {
    const { showDifferencesOnly, supplierId } = self.state.filterDto ?? {}

    if (showDifferencesOnly && each.newPrice === each.price) {
      return false
    }

    if (supplierId && each.supplierId !== supplierId) {
      return false
    }

    return true
  },
  getRowSelectionCheckboxProps: (self) => (record) => ({
    disabled: record.newPrice === record.price,
  }),
})(Filter)
